import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { localCompareEnglish } from '@shared/utils/sorting-localcompare-util';

import { StockTransferItem } from '../../models/stock-transfer-request.model';
import {
  StockProductSelectedActionTypes,
  StockProductSelectedActions
} from '../actions/stock-product-selected.actions';

export interface StockProductSelectedState extends EntityState<StockTransferItem> {
  isLoading: boolean;
}

export function sortList(a: StockTransferItem, b: StockTransferItem) {
  const aProductName = a.productName;
  const bProductName = b.productName;
  return localCompareEnglish(aProductName, bProductName);
}

export const adapter: EntityAdapter<StockTransferItem> = createEntityAdapter<StockTransferItem>({
  selectId: (stockTransferItem: StockTransferItem) => `${stockTransferItem.articleNo}`,
  sortComparer: sortList
});

export const initialStockProductSelectedState: StockProductSelectedState = adapter.getInitialState({
  isLoading: false
});

export function stockProductSelectedReducers(
  state = initialStockProductSelectedState,
  action: StockProductSelectedActions
): StockProductSelectedState {
  switch (action.type) {
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_ADD_ITEM:
      return adapter.upsertOne(action.payload, {
        ...state
      });
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_UPDATE_ITEM:
      return adapter.updateOne(
        {
          id: action.payload.articleNo,
          changes: { ...action.payload }
        },
        {
          ...state
        }
      );
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_UPDATE_ITEMS:
      return adapter.updateMany(
        action.payload.map(item => ({
          id: item.articleNo,
          changes: { ...item }
        })),
        {
          ...state
        }
      );
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_ADD_ALL_ITEM:
    case StockProductSelectedActionTypes.PURCHASE_REQUEST_ITEM_SELECTED_LIST:
      return adapter.upsertMany(action.payload, {
        ...state
      });
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_INSERT_ALL_ITEM:
      return adapter.setAll(action.payload, {
        ...state
      });
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_REMOVE_ITEM:
      return adapter.removeOne(action.payload, {
        ...state
      });
    case StockProductSelectedActionTypes.STOCK_PRODUCT_SELECTED_RESET:
      return adapter.removeAll({
        ...state
      });

    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
